import '../scss/panels.scss'
import React, {useEffect, useRef, useState} from "react";
import {Box3, Euler, Quaternion, Vector3} from "three";
import {useSnapshot} from "valtio";
import {
  setWall1State,
  modulesState,
  configuratorState,
  panelsState,
  removeLeftWall,
  removeRightWall,
  addModule,
  setRemoveModuleRight,
} from "../../../state";

import {MemModuleModel} from "../module/ModuleModel";
import PanelsBuilderGUI from "./ui/PanelsBuilderGUI";
const FrontWallGenerator = ({props, geometriesData, camera, staticModulesRef, datumPoint}) => {
  const smallDiff = 0.599563300583724;
  const largeDiff = 1.197002410893226;
  let diff = largeDiff;
  
  let leftCount = 0;
  let rightCount = 0;

  
  if (!geometriesData) return;
  
  const {wall1DoorPosition,wall2DoorPosition,shedSize,selectedStructure,modelPartsMenu,selectedSecurity,activeWall} = useSnapshot(configuratorState);
  const [panels, setPanels] = useState({width:Math.floor(shedSize[0]), depth:Math.floor(shedSize[1]), widthSmallPanel:shedSize[0]%1!==0, depthSmallPanel:shedSize[1]%1!==0});
  const {activeModules, activeModulesStatus, removedModuleStatus} = useSnapshot(modulesState);
  const {panelLast, panelTotals} = useSnapshot(panelsState);
  const [initiated, setInitiated] = useState(false);

  // local state
  const [activeModulesLeft] = useState([]);
  const [activeModulesRight] = useState([]);
  const [activeHtml] = useState([]);
  
  const modulePrototypes = geometriesData.availableModules;
  const moduleContainer = useRef();
  const modulesRef = useRef([]);
  

  const getNodeData = (node) => {
    
    const position = new Vector3();
    const quaternion = new Quaternion();
    const rotation = new Euler();
    const scale = new Vector3();
    
    if (modulesRef.current.length > 0) {
      
      node.updateMatrixWorld();
      node.matrixWorld.decompose(position, quaternion, scale);
      rotation.setFromQuaternion(quaternion, 'XYZ');
      
    }
    
    return {position, rotation};
  }
  
  const getNode = (dir, lastRef) => {
    
    const module = modulesRef.current.find(m => m['refNo'] === lastRef.ref && m.dir === lastRef.dir);
    
    return (dir === 'left') ?
      module.children[0].children.find(m => m.name === 'Node_Left') :
      module.children[0].children.find(m => m.name === 'Node_Right');
    
  }
  
  const setModuleLeft = (moduleProto, dir) => {
    
    if (activeModulesLeft.length > 0) {
      
      const node = getNode(dir, activeModulesLeft[0]);
      // set node rotation
      node.rotation.y = moduleProto.rotaLeftY + node.rotation.y;

      setModule(node, moduleProto, dir);
    }
  }
  
  const setModuleRight = (moduleProto, dir) => {
    
    if (activeModulesRight.length > 0) {
      
      const node = getNode(dir, activeModulesRight[0]);
      // set node rotation
      node.rotation.y = moduleProto.rotaRightY + node.rotation.y;
      
      setModule(node, moduleProto, dir);
    }
  }
  
  // remove & reset prev node
  const removeModuleLeft = () => {
    
    // remove & set prev node rotation - default
    activeModulesLeft.pop();
    
    const lastRefL = activeModulesLeft[activeModulesLeft.length - 1];
    const node = getNode('left', activeModulesLeft[activeModulesLeft.length - 1]);
    node.rotation.y = modulePrototypes.find(m => m.name === lastRefL.name).rotaLeftY;
    
  }
  
  const removeModuleRight = () => {
    
    // remove & set prev node rotation - default
    activeModulesRight.pop();
    
    const lastRefR = activeModulesRight[activeModulesRight.length - 1];
    const node = getNode('right', activeModulesRight[activeModulesRight.length - 1]);
    node.rotation.y = modulePrototypes.find(m => m.name === lastRefR.name).rotaRightY;
    
  }
  
  const add = (node, moduleProto, dir, initStatus) => {
    
    let moduleData;
    
    // add module
    if (node) {
      moduleData = getNodeData(node);
    } else {
      // on init or change primary module
      moduleData = {
        position: new Vector3(),
        rotation: new Euler(),
      }
    }
    
    if(leftCount>0&& dir==="left"){
      moduleData.position.x+=(diff * (leftCount));
      if(leftCount>=1 && (wall1DoorPosition=="left" || (panels.width<=2 && wall1DoorPosition!=="none" && !panels.widthSmallPanel)|| (wall1DoorPosition=="right" && !panels.widthSmallPanel)))moduleData.position.x-=smallDiff;
    }
    
    if(rightCount>0&& dir==="right"){
      moduleData.position.z-=(diff * (rightCount));
      if(rightCount>=1&& wall2DoorPosition=="right" || (panels.depth<=2 && wall2DoorPosition!=="none" && !panels.depthSmallPanel)|| (wall2DoorPosition=="left" && !panels.depthSmallPanel))moduleData.position.z+=smallDiff;
    }

    dir=="right" && rightCount++;

    if(dir=="left" && moduleProto.name!=="datum-node") {
      leftCount++;
      // if(moduleProto.name.includes("1200"))leftCount++
    }

    if(!panels.widthSmallPanel && leftCount>=panels.width+1){
      leftCount = 0;
    }
    else if(leftCount>=panels.width+1)
    {
      leftCount = 0;
    }

    if(!panels.depthSmallPanel && rightCount>=panels.depth+1){
      rightCount = 0;
    }
    else if(rightCount>=panels.depth+1)
    {
      rightCount = 0;
    }

    addModule({
      name: moduleProto.name,
      dir: dir,
      ref: null,
      vis: true,
      pos: moduleData.position,
      rotation: moduleData.rotation,
    }, initStatus);
    
  }
  
  // set new module
  const setModule = (node, moduleProto, dir) => {
    add(node, moduleProto, dir, false)
  }
  
  // set / change initial module - always start or change left
  const setInitialModule = () => {
    //
    add(false, modulePrototypes.find(obj => obj.name === 'datum-node'), 'left', true)
    
  }


  // on update - after render modules
  useEffect(() => {
    
    if (!activeModules[0]) return;
    
    // clean up
    modulesRef.current = modulesRef.current.filter(module => {
      return module !== null;
    });
    
    // local state lists - left / right
    if (activeModulesStatus === 'add') {
      
      // on init - copy to both sides lists
      if (activeModules.length === 1) {
        activeModulesLeft[0] = activeModules[0];
        activeModulesRight[0] = activeModules[0];
        return;
      }
      
      const activeModule = activeModules[modulesRef.current.length - 1];
      
      if (activeModule.dir === 'left') {
        activeModulesLeft.push(activeModule);
        return;
      }
      
      if (activeModule.dir === 'right') {
        activeModulesRight.push(activeModule);
        return;
      }
    }
    
    // remove from local state & update (reset) node pos
    if (activeModulesStatus === 'remove') {
      
      if (removedModuleStatus === 'left') {
        removeModuleLeft();
        return;
      }
      if (removedModuleStatus === 'right') {
        removeModuleRight();
      }
    }
    
  }, [activeModules, activeModulesStatus, removedModuleStatus]);  
  
  useEffect(() => {
    const addWall = (side) => {
      let small,node,door;
      modulePrototypes.forEach((moduleProto, index)=> {
        // panel-H-Series-Horiz-Timber-Door-EUi-1200
        moduleProto.name===`panel-H-Series-${selectedStructure}-Panel-1200` && (node=modulePrototypes[index])
        moduleProto.name===`panel-H-Series-${selectedStructure}-Panel-600` && (small=modulePrototypes[index])
        moduleProto.name===`panel-H-Series-${selectedStructure}-Door-${selectedSecurity}${selectedStructure==="Horiz-Timber"&& selectedSecurity==="EU"?"i":""}-1200` && (door=modulePrototypes[index])
      })
      if(side==="left"){
        initiated?removeLeftWall():null;
        if(wall1DoorPosition==="none"){
          for(let i = 0; i<panels.width; i++){
            setModuleLeft(node, 'left')
          }
          panels.widthSmallPanel && setModuleLeft(small, 'left')
        }
        else{
          if(wall1DoorPosition==="left" || (panels.width<=2&&!panels.widthSmallPanel)){
            setModuleLeft(small, 'left');
            setModuleLeft(door, 'left');
            const sub = panels.widthSmallPanel?1:2;
            for(let i = 0; i<panels.width-sub; i++){
              setModuleLeft(node, 'left')
            }
            !panels.widthSmallPanel && setModuleLeft(small, 'left')
          }
          else if(wall1DoorPosition==="right"){
            !panels.widthSmallPanel && setModuleLeft(small, 'left')
            const sub = panels.widthSmallPanel?1:2;
            for(let i = 0; i<panels.width-sub; i++){
              setModuleLeft(node, 'left')
            }
            setModuleLeft(door, 'left');
            setModuleLeft(small, 'left')
          }
          else if(wall1DoorPosition==="center"){
            for(let i = 0; i<Math.floor(panels.width/2); i++){
              setModuleLeft(node, 'left')
            }
            setModuleLeft(door, 'left');
            for(let i = 0; i<Math.ceil(panels.width/2)-1; i++){
              setModuleLeft(node, 'left')
            }
            panels.widthSmallPanel && setModuleLeft(small, 'left')
          }
         
        }
        setWall1State(true)
      }
      else{
        initiated?removeRightWall():null;
        if(wall2DoorPosition==="none"){
          for(let i = 0; i<panels.depth; i++){
            setModuleRight(node, 'right')
          }
          panels.depthSmallPanel && setModuleRight(small, 'right')
        }
        else{   
          if(wall2DoorPosition==="right" || (panels.depth<=2&&!panels.depthSmallPanel)){
            setModuleRight(small, 'right');
            setModuleRight(door, 'right');
            const sub = panels.depthSmallPanel?1:2;
            for(let i = 0; i<panels.depth-sub; i++){
              setModuleRight(node, 'right')
            }
            !panels.depthSmallPanel && setModuleRight(small, 'right')
          }
          else if(wall2DoorPosition==="left"){
            !panels.depthSmallPanel && setModuleRight(small, 'right')
            const sub = panels.depthSmallPanel?1:2;
            for(let i = 0; i<panels.depth-sub; i++){
              setModuleRight(node, 'right')
            }
            setModuleRight(door, 'right');
            setModuleRight(small, 'right')
          }
          else if(wall2DoorPosition==="center"){
            for(let i = 0; i<Math.floor(panels.depth/2); i++){
              setModuleRight(node, 'right')
            }
            setModuleRight(door, 'right');
            for(let i = 0; i<Math.ceil(panels.depth/2)-1; i++){
              setModuleRight(node, 'right')
            }
            panels.depthSmallPanel && setModuleRight(small, 'right')
          }
        }
      }
      setInitiated(true)
    }

    if(selectedStructure){
      // set first module
      activeWall==="wall1"?addWall("left"):activeWall==="wall2"?addWall("right"):null;
    }
    setInitialModule();
      
  }, [wall1DoorPosition,wall2DoorPosition,panels.width,selectedStructure,modelPartsMenu,selectedSecurity]);
  
  return (
    
    <group {...props} ref={moduleContainer}>
      
      {activeModules.map((item, index) => {
        let posX, posZ, rota, nodeOffSet, modulesSet, hide = false;
        // datum module
        if (index === 0&& staticModulesRef.current.length>0) {
          
          // build from module prototypes
          modulesSet = modulePrototypes.find(obj => obj.name === 'datum-node');
          
          // node offset group
          nodeOffSet = 0;

          let datumModule = staticModulesRef.current.find(obj => obj.name === datumPoint);
          
          posX = datumModule.position.x;
          posZ = datumModule.position.z;
          rota = datumModule.rotation;
          
        } else {
          
          // build from module prototypes
          modulesSet = modulePrototypes.find(obj => obj.name === item.name);
          
          // node offset group
          nodeOffSet = (item.dir === 'left') ? modulesSet.nodeLeft : modulesSet.nodeRight;
          
          posX = item.pos.x;
          posZ = item.pos.z;
          rota = item.rotation;
          
        }
        
        // hide first and last post
        if (item.dir === 'right') {
          hide = (item.ref === 0);
        } else {
          hide = (panelLast.lastFrontLeft && item.ref === activeModulesLeft[activeModulesLeft.length - 1].ref);
        }
        
        return (
          
          <group dir={item.dir} key={index} index={index} refNo={item.ref} name={item.name}
                 ref={(el) => (modulesRef.current[index] = el)}
                 position={[posX, 0, posZ]} rotation={rota}>
            
            <group name={item.name} position={[nodeOffSet, 0, 0]} visible={item.vis}>
              
              {modulesSet.meshSet.map((geom, index) => {
                
                //const type = (!(hide && geom.name.includes('Post')));
                let type;
                if(["Toggle"].includes(geom.name.split("_")[0]))
                {
                  if(hide && geom.name.includes('Post'))
                  {
                    type = false;
                  }
                  else
                  {
                    type = {group: "toggle", set: geom.name.split("_").pop()}
                  }
                }
                else
                {
                  type = (!(hide && geom.name.includes('Post')));
                }
                
                return (
                  <MemModuleModel key={index} geom={geom} material={geom.material} att={type}/>
                )
              })}
            </group>
          </group>
        );
      })} 
    </group>
  
  );
};

export default FrontWallGenerator;

